<template>
    <a-row type="flex" v-if="employee.investment_manager[0]">
      <a-col class="team_employee" v-for="(item, index) in employee.investment_manager"
             v-on:mouseover="employee.investment_manager[index].active = true"
             v-on:mouseleave="employee.investment_manager[index].active = false"
             :key="index">
        <img :src="item.picture" class="image">
        <h1 class="team_employee_name" v-if="employee.investment_manager[index].active">
          {{ employee.investment_manager[index].name }}</h1>
      </a-col>
    </a-row>
</template>

<script>
import axios from "axios";
import {reactive, onMounted} from 'vue'

export default {
  name: 'Team_manager_m',
  setup() {
    let employee = reactive({
      investment_manager: [],
    })

    onMounted(() => {
      axios.get('https://sig-china.com:8081/api/employee/manager')
          .then((res) => {
                for (let i = 0; i < res.data.length; i++) {
                  employee.investment_manager.push(res.data[i])
                }
                employee.investment_manager.sort((a, b) => {
                  return a['id'] - b['id']
                })
                for (let i = 0; i < employee.investment_manager.length; i++) {
                  employee.investment_manager[i]['picture'] = 'https://sig-china.com' + employee.investment_manager[i]['picture']
                  employee.investment_manager[i].active = false
                }
              }
          )
    })

    return {employee}
  }
}
</script>
<style scoped>
.team_employee {
  width: 50vw;
  align-items: center;
  justify-content: center;
  position: relative;
}

.image {
  width: 50vw;

}

.team_employee_name {
  z-index: 2;
  position: absolute;
  bottom: 3vh;
  left: 2vw;
}

.image:hover {
  opacity: 0.5;
}

</style>
